import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { ColorButton, MeterReadingRecord } from '../../../../index.js';
import moment from 'moment';
import Autoload from '../../../../Autoload';
import uparrow from '../../../../../assets/images/module/general/SelectArrowUp.svg';
import downArrow from '../../../../../assets/images/module/general/SelectArrowDown.svg';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core';
import MobileHeadingContainer from '../MobileHeadingContainer/index.js';
import APIClient from '../../../../config/APIClient.js';
import { Group, Loader, Skeleton, Stack } from '@mantine/core';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const MOBILE_SIZE = 992;
const SMALLER_MOBILE_SIZE = 410;

export default function OtherBillingPeriodMeter({ item, history, parent, data, index, newDate, rentalUnitsExist, propertySelected }) {
  console.log(item)
  const [accordianArrow, setaccordianArrow] = useState(false);
  const [itemData, setItemData] = useState(item);
  const [loader, setLoader] = useState(false);
  var isMobile = window.innerWidth <= MOBILE_SIZE;
  var isSmallMobile = window.innerWidth <= SMALLER_MOBILE_SIZE;

  let badgeText = '';
  let badgeStyle = '';
  
  const itemYear = moment(item.billingPeriodData.endDate).year();
  const currentYear = new Date().getFullYear();
  const dateDiff = currentYear - itemYear;
  
  switch (item.type) {
    case 'current':
      badgeText = isMobile ? lang.receipt.text_mobile_current_billing_period : lang.receipt.text_current_billing_period;
      badgeStyle = 'white';
      break;
    case 'last':
      badgeText = isMobile ? lang.receipt.text_mobile_last_billing_period : lang.receipt.text_last_billing_period;
      badgeStyle = 'purple';
      break;
    default:
      badgeText = '';
      badgeStyle = '';
      break;
  }

  const getOccupationReadings = (billingPeriod, index, type = 'other') => {
    setLoader(true);
    console.log('_getOccupationReadings', billingPeriod);
    const propertyid = propertySelected && propertySelected.id;
    
    APIClient({
      method: "GET",
      url: Autoload.Setting.meter_api_base_url + 'occupationReadings?propertyId=' + propertyid + '&billingPeriodId=' + billingPeriod.id + '&isMissingReadingsCreationEnabled=false',
      headers: { Authorization: Autoload.Utils.getAuthToken() }
    })
      .then((response) => {
        if (response.data.status && response.status === 200) {
          // Use raw response.data.result instead of MeterDataHandler.
          let rawReadings = response.data.result;

          // Manually sort: Property Meters (no rental unit name) first, then alphabetical
          const newOccupationReadings = rawReadings.sort((a, b) => {
            const aIsProperty = !a.rentalUnitName; // Check if name is null/undefined/empty
            const bIsProperty = !b.rentalUnitName;

            if (aIsProperty && !bIsProperty) return -1; // Property first
            if (!aIsProperty && bIsProperty) return 1;

            return (a.rentalUnitName || '').toLowerCase().localeCompare((b.rentalUnitName || '').toLowerCase());
          });
          
          let newItemData = { ...itemData };
          newItemData.occupationReadings = newOccupationReadings;
          setItemData(newItemData);
          setLoader(false);
        }
      }).catch((e) => {
        setLoader(false);
        console.log('getOccupationReadingsError: ', e);
      });
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      isMobile = window.innerWidth <= MOBILE_SIZE;
      isSmallMobile = window.innerWidth <= SMALLER_MOBILE_SIZE;
    }, [window.innerWidth]);
  })

  useEffect(() => {
    if (accordianArrow && item.occupationReadings.length === 0) {
      getOccupationReadings(item);
    }
  }, [accordianArrow]);

  useEffect(() => {
    setItemData(item);
  }, [item]);

  return (
    <div className={`meter-billing-period-${index}`}>
      <Accordion key={index}>
        <AccordionSummary
          aria-controls="panel2a-content"
          id="panel2a-header"
          onClick={() => {
            setaccordianArrow(!accordianArrow);
          }}
        >
          <Typography>
            <MobileHeadingContainer
              className="meter-reading-heading"
              isMobile={isMobile}
              heading={
                <div className="d-flex" style={{ marginLeft: isMobile && window.innerWidth <= 992 && '0px', minWidth: '80px', whiteSpace: 'nowrap', marginTop: !isMobile && '7px' }}>
                  <div style={{ marginRight: '12px' }}>
                    <img src={accordianArrow === false ? downArrow : uparrow} alt="icon" style={{ minWidth: '8px' }} />
                  </div>
                  <div style={{
                    fontSize: isMobile ? '14px' : '16px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '24px',
                    color: '#000000'
                  }}>
                    {`${moment(item.billingPeriodData.startDate).format('DD.MM.YYYY')} - ${moment(
                      item.billingPeriodData.endDate
                    ).format('DD.MM.YYYY')}`}
                  </div>
                </div>
              }
              headingButton={
                isMobile &&
                <ColorButton
                  onClick={() =>
                    history.push({
                      pathname: `${Autoload.Setting.get_meter_reading_annual_link(item.id, 'c-r-0')}`,
                      data: { ...item, badgeText },
                      edit: false,
                    })
                  }
                  buttonStyle={{ maxWidth: isMobile && 'auto', maxHeight: isMobile && '35px', marginRight: '0px !important' }}
                  text={lang.meter.text_mobile_individual_reading}
                  textStyle={{ fontSize: isMobile && 12 }}
                  className={` mr-1 annual-btn purple-btn meter-billing-period-button-${index}`}
                />
              }

              rightContent={!isMobile &&
                <div className="btn-container meter-reading-buttons" style={{ justifyContent: 'flex-end', marginRight: isMobile && window.innerWidth <= 400 && '16px', marginTop: isMobile && '16px' }}>
                  {!isMobile && <ColorButton
                    onClick={() => {
                      history.push({
                        pathname: `${Autoload.Setting.get_meter_reading_annual_link(item.id, 'c-r-0')}`,
                        data: { ...item, badgeText },
                        edit: false,
                      })
                    }}
                    text={lang.meter.text_reading}
                    className={` mr-1 ${badgeText !== '' ? 'annual-btn purple-btn' : ' annual-btn gray-btn '} meter-billing-period-button-${index}`}
                  />}
                </div>
              }
              badge={
                !isSmallMobile &&
                <div style={{ marginTop: !isMobile && '6px' }}>
                  <Badge variant="info" className={`year-badge ${badgeStyle}`} style={{
                    backgroundColor: badgeStyle === 'purple' ? '#F2F2FC' : 'white',
                    color: badgeStyle === 'purple' ? '#5555FF' : '#727293',
                    fontSize: isMobile ? '12px' : '14px',
                    fontWeight: '500',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    marginLeft: window.innerWidth <= 350 ? '45px' : '10px',
                    padding: '4px 8px',
                    lineHeight: '20px',
                    borderRadius: '4px'
                  }}>
                    {badgeText}
                  </Badge>
                </div>
              }
            />
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ width: '100%' }}>
            {loader ?
              <Stack style={{ marginTop: '40px' }}>
                <Group>
                  <Skeleton height={28} width={234} />
                </Group>
                <Stack gap={10} style={{ marginTop: '16px' }}>
                  <Skeleton style={{ width: '100%', height: '22px' }} />
                  <Skeleton style={{ width: '100%', height: '69.5px' }} />
                </Stack>
                <Group style={{ marginTop: '16px' }}>
                  <Skeleton height={28} width={234} />
                </Group>
                <Stack gap={10} style={{ marginTop: '16px' }}>
                  <Skeleton style={{ width: '100%', height: '22px' }} />
                  {[...Array(3)].map((e, i) => <Skeleton style={{ width: '100%', height: '69.5px' }} />)}
                </Stack>
              </Stack>
              :
              itemData.occupationReadings.length === 0
                ? null : (
                  <MeterReadingRecord
                    className="meter-reading-table"
                    data={itemData}
                    labels={[
                      lang.meter.text_Rental_Unit,
                      lang.tenant.text_tenant,
                      lang.utility.text_occupancy_period,
                      lang.meter.text_status,
                      lang.general.text_date,
                    ]}
                    labelClassName={['unit', 'tenant', 'Occupation period', 'status', 'date', '']}
                    history={history}
                    parent={parent}
                    billingPeriod={dateDiff}
                    rentalUnitsExist={rentalUnitsExist}
                  />
                )}
            {data.length !== index + 1 && <div className="divider"></div>}
          </Typography>
        </AccordionDetails>
      </Accordion>
      <hr />
    </div>
  );
}
